import React from 'react';
import { doctorHomeImages } from '../../../config';
import withAnimation from '../../../hooks/withAnimation';
import { useNavigate } from 'react-router-dom';
import { routeNames } from '../../../routes/routeNames';

const demoexperts = [
  {
    name: 'Dr. Aditya Shashtri',
    specialization: 'Physiotherapist',
    degree: 'M.Sc (Physiotherapist)',
    experience: '18 years of experience',
    tags: ['Knee Pain', 'Hip Pain', 'Ligament and Sports surgeries'],
    image: doctorHomeImages.doctor4
  },
  {
    name: 'Dr. Paul Sidhu',
    specialization: 'Physiotherapist',
    degree: 'M.Sc (Physiotherapist)',
    experience: '19 years of experience',
    tags: ['Shoulder Pain', 'Back Pain', 'Knee Pain', '+1'],
    image: doctorHomeImages.doctor6
  },
  {
    name: 'DR. Gargi Naha',
    specialization: 'Physiotherapist',
    degree: 'MPTh (Ortho)',
    experience: '14 years of experience',
    tags: ['Sports Injury', 'Back Pain', 'Neck Pain', '+3'],
    image: doctorHomeImages.doctor5
  },
  
];

const MeetOurExperts = ({experts = demoexperts}) => {

  const navigate = useNavigate()
  return (
    <section className="bg-white py-12">
    <div className="container mx-auto px-4">
      <h2 className="text-3xl text-primary pb-4 font-bold text-center mb-8 lg:text-4xl">Meet Our Experts</h2>
      <div className="flex flex-wrap justify-around gap-8">
        {experts.map((expert, index) => (
          <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden max-w-80">
            <img src={expert.image} alt={expert.name} className="w-full pt-5 h-72 object-cover p-5" />
            <div className="p-6">
              <h3 className="text-xl font-bold">{expert.name}</h3>
              <p className="text-gray-600">{expert.specialization}</p>
              <p className="text-gray-600">{expert.degree}</p>
              <p className="text-gray-600">{expert.experience}</p>
              <div className="flex flex-wrap mt-4">
                {expert.tags.map((tag, index) => (
                  <span key={index} className="bg-green text-white text-sm font-medium mr-2 mb-2 px-2.5 py-0.5 rounded-full">{tag}</span>
                ))}
              </div>
              <button onClick={()=>navigate(routeNames.teammemberdetail)} className="mt-4 w-full py-2 px-4 border border-primary text-primary font-semibold rounded-full hover:bg-primary hover:text-white transition">Know More</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default withAnimation(MeetOurExperts);
